import React, { Component } from "react";
import { Container, Row, Col, Form } from "react-bootstrap"
import { TableCell, TableRow } from "@mui/material";
import RemoveIcon from '@mui/icons-material/Delete';
import PhoneClinicGrid from "../../../Components/PhoneClinicGrid";
import RowActions from "../../../Components/PhoneClinicGrid/RowActions";
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';
import FormCard from '../shared/FormCard';
// import RemoveIcon from '@mui/icons-material/Delete';
// import { debounceFunc } from './../../../helper'

class BrandSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BrandList: [],
            addBrand: false,
            Brand_ID: "",
            Brand_Name: "",
            Active: "1",

            BRAND_SEARCH: ""
        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     let { BRAND_SEARCH, searchGridData, totalRecordsPerPage, paginationValue } = this.state
    //     this.getBrandList(BRAND_SEARCH, searchGridData, totalRecordsPerPage.value, paginationValue)
    // }

    // Brand_Name
    async getBrandList(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getDevice = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Setups/ItemBrand.php`, formData);
        let deviceData = getDevice.data
        let BrandList = []
        if (deviceData.success === 1) {
            BrandList = deviceData.data
            pagination.totalItems = parseInt(deviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ BrandList })
        this.props.toggleLoader(false)
    }

    handleAddBrand() {
        this.setState({ addBrand: true })
    }

    handleChangeInput(fieldName, event) {
        let targetValue = event.target.value
        this.setState({ [fieldName]: targetValue })
    }


    handleExit() {
        this.setState({
            addBrand: false,
            Brand_ID: "",
            Brand_Name: "",
            Active: "1",
        })
    }

    async handleSubmitDevice() {
        this.props.toggleLoader(true)
        let formData = {
            Brand_ID: this.state.Brand_ID,
            Brand_Name: this.state.Brand_Name,
            Active: this.state.Active,
        }

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/Setups/ItemBrand.php`, formData);

        this.handleExit()
        this.getBrandList()
    }


    handleEdit(indx) {
        let { BrandList } = this.state
        this.setState({
            Brand_ID: BrandList[indx]['Brand_ID'],
            Brand_Name: BrandList[indx]['Brand_Name'],
            Active: BrandList[indx]['Active'],
            addBrand: true
        })
    }

    render() {
        return (
            <Container>
                {this.state.addBrand === false ?
                    <PhoneClinicGrid
                        title="BRAND"
                        buttonLabel="Add Brand"
                        isEditable={true}
                        ref={this.gridRef}
                        getData={this.getBrandList.bind(this)}
                        onClickButton={this.handleAddBrand.bind(this)}
                        tableHeadData={[
                            {
                                label: "BRAND",
                                isHidden: false
                            },
                            {
                                label: "ACTIVE",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.BrandList.map((device, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                style={{ whiteSpace: 'nowrap' }}
                            >

                                <TableCell align='left'>{device.Brand_Name}</TableCell>
                                <TableCell align='center'>
                                    <Checkbox style={{ padding: "0px" }} size="small" checked={true} disabled />
                                </TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                    :
                    <>
                        <FormCard title={this.state.Brand_ID ? 'Edit Brand' : 'Add Brand'} mode={this.state.Brand_ID ? 'edit' : 'new'}
                            onCancel={this.handleExit.bind(this)}
                            onSave={this.handleSubmitDevice.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        value={this.state.Brand_Name}
                                        name={"Brand_Name"}
                                        onChange={this.handleChangeInput.bind(this, "Brand_Name")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_BRAND}
                                        name={"DEVICE_BRAND"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_BRAND")}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Model</Form.Label>
                                    <Form.Control
                                        value={this.state.DEVICE_NAME}
                                        name={"DEVICE_NAME"}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        </FormCard>
                    </>
                }
            </Container>
        );
    }
}

export default BrandSetup;